import React, { Fragment } from 'react';
import { SearchX, FileWarning, Network, TrendingDown } from 'lucide-react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
export function Problems() {
  const problems = [{
    icon: SearchX,
    title: 'Buried in Search Results',
    description: 'Most e-learning platforms invest heavily in course quality but neglect discoverability, losing potential learners to competitors with inferior content but stronger SEO.',
    color: 'bg-rose-100/50 text-rose-900 border-rose-200'
  }, {
    icon: FileWarning,
    title: "Content That Doesn't Convert",
    description: 'Blog posts and landing pages that fail to speak the language of prospective learners, resulting in high bounce rates and empty enrollment funnels.',
    color: 'bg-lavender-100/50 text-lavender-900 border-lavender-200'
  }, {
    icon: Network,
    title: 'Fragmented Marketing Efforts',
    description: 'Disconnected SEO, content, and social strategies that waste budget without compounding results or building long-term domain authority.',
    color: 'bg-sage-100/50 text-sage-900 border-sage-200'
  }, {
    icon: TrendingDown,
    title: 'Scaling Without Direction',
    description: 'Growing course catalogs without a logical content architecture that search engines can crawl, understand, and index effectively.',
    color: 'bg-blue-100/50 text-blue-900 border-blue-200'
  }];
  return <section id="problems" className="py-24 md:py-32 bg-white" data-id="element-123">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-124">
        <FadeIn className="max-w-3xl mb-16" data-id="element-125">
          <h2 className="text-sm font-bold tracking-widest text-sage-800 uppercase mb-4" data-id="element-126">
            The Challenge
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-slate-900 leading-tight mb-6" data-id="element-127">
            The Visibility Gap in E-Learning
          </h3>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-128">
            Creating exceptional educational content is only half the battle.
            Without a strategic approach to organic discovery, even the best
            courses remain hidden from the students who need them most.
          </p>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-129">
          {problems.map((problem, idx) => <StaggerItem key={idx} data-id="element-130">
              <div className={`h-full p-8 md:p-10 rounded-3xl border transition-all duration-300 hover:shadow-lg hover:-translate-y-1 ${problem.color} bg-opacity-30 backdrop-blur-sm`} data-id="element-131">
                <div className="w-14 h-14 rounded-2xl bg-white/80 flex items-center justify-center mb-6 shadow-sm" data-id="element-132">
                  <problem.icon size={28} className="opacity-80" data-id="element-133" />
                </div>
                <h4 className="text-2xl font-serif font-medium mb-4" data-id="element-134">
                  {problem.title}
                </h4>
                <p className="text-slate-700 leading-relaxed opacity-90" data-id="element-135">
                  {problem.description}
                </p>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}